import logo_tipddy from "./assets/logo-tipddy.png";
import "./index.css";
import { useTheme } from "../../contexts/ThemeContext";
import { Link } from "react-router-dom";
import { useConfig } from "../../contexts/config";
import React from "react";
import { readableColor } from "polished";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";

export const Footer = () => {
  const { config } = useConfig();
  const theme = useTheme();

  const contrastColorSecondary = () => {
    if (theme?.colors?.backgroundColorNavBar) {
      return readableColor(
        theme.colors.backgroundColorNavBar,
        "#000",
        "#fff",
        false
      );
    }
    return "#fff";
  };
  
  return (
    <>
      {/* <div className="wrapper fon-footer sale-movil" style={theme.styles.nav}>
        <div className="container"> */}
      <div
        style={{ backgroundColor: theme.colors.backgroundColorFooter }}
        className="flex flex-col justify-between items-center tablet:items-end gap-8 tablet:gap-0 px-[3rem] tablet:px-[6rem] tablet:flex-col tablet:p-[4rem] tablet:!pb-[1rem]  "
      >
        <div className="flex flex-col gap-10 tablet:gap-0 tablet:flex-row tablet:justify-between w-full">
          <div className="flex flex-col tablet:flex-row gap-16 ">
            <div className="flex flex-col items-center tablet:items-start">
              <p
                className="text-3xl font-semibold mb-4"
                style={{ color: contrastColorSecondary() }}
              >
                Accesos directos
              </p>
              <ul className="!list-none flex flex-col gap-3 [&_a]:mx-0">
                <li className="px-0">
                  <a
                    href="http://roboticavirtual.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-2xl hover:underline mx-0"
                    style={{ color: contrastColorSecondary() }}
                  >
                    Roboticavirtual
                  </a>
                </li>
                <li>
                  <a
                    href="http://robotvirtualgames.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-2xl hover:underline"
                    style={{ color: contrastColorSecondary() }}
                  >
                    Robotvirtualgames
                  </a>
                </li>
                <li>
                  <Link
                    to="/listcourses/progress"
                    className="text-2xl hover:underline"
                    style={{ color: contrastColorSecondary() }}
                  >
                    Historial
                  </Link>
                </li>
                <li>
                  <Link
                    to="/userpreferences"
                    className="text-2xl hover:underline"
                    style={{ color: contrastColorSecondary() }}
                  >
                    Preferencias
                  </Link>
                </li>
                <li>
                  <Link
                    to="/terms"
                    className="text-2xl hover:underline"
                    style={{ color: contrastColorSecondary() }}
                  >
                    Términos y condiciones
                  </Link>
                </li>
                <li>
                  <Link
                    to="/privacy"
                    className="text-2xl hover:underline"
                    style={{ color: contrastColorSecondary() }}
                  >
                    Política de privacidad
                  </Link>
                </li>
              </ul>
            </div>

            {/* Social media column */}
            <div className="flex flex-col items-center tablet:items-start  [&_a]:mx-0">
              <p
                className="text-3xl font-semibold mb-4"
                style={{ color: contrastColorSecondary() }}
              >
                Conecta con nosotros
              </p>
              <div className="flex gap-4">
                <a
                  href=""
                  target="_blank"
                  rel="noreferrer"
                  className="text-4xl hover:opacity-80"
                >
                  <FacebookIcon
                    style={{
                      fontSize: "3rem",
                      color: contrastColorSecondary(),
                    }}
                  />
                </a>
                <a
                  href="https://www.instagram.com/aprendersteam/?hl=es"
                  target="_blank"
                  rel="noreferrer"
                  className="text-4xl hover:opacity-80"
                >
                  <InstagramIcon
                    style={{
                      fontSize: "3rem",
                      color: contrastColorSecondary(),
                    }}
                  />
                </a>
                <a
                  href=""
                  target="_blank"
                  rel="noreferrer"
                  className="text-4xl hover:opacity-80"
                >
                  <YouTubeIcon
                    style={{
                      fontSize: "3rem",
                      color: contrastColorSecondary(),
                    }}
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="w-[16rem]  tablet:w-[26rem] h-auto flex self-center tablet:items-center tablet:justify-center  mb-4">
            <img
              src={
                config.config.theme &&
                (theme && theme.mode === "light"
                  ? config.config.theme.logo
                  : config.config.theme.theme_logo_dark)
              }
              alt="Academia Tecnigen Logo"
              className="max-w-full  max-h-[15rem] object-contain"
            />
          </div>
        </div>

        {/* Tipddy attribution - at the bottom */}
        <div className="flex flex-row items-center gap-2 py-4  border-t border-gray-700/30 w-full justify-center">
          <img
            src={logo_tipddy}
            alt="Tipddy Logo"
            className="h-6 w-auto object-contain"
          />
          <p
            className="text-2xl font-medium opacity-80 flex items-center"
            style={{ color: contrastColorSecondary() }}
          >
            &copy; {new Date().getFullYear()} Powered by Tipddy
          </p>
        </div>
      </div>
    </>
  );
};
